import { render, staticRenderFns } from "./NextPageLink.vue?vue&type=template&id=62385f6f&"
import script from "./NextPageLink.vue?vue&type=script&lang=js&"
export * from "./NextPageLink.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports